import { ProviderActivationEventName } from '@uplift/api';
import { useAddProviderActivationEventMutation } from '@uplift/queries';

export const useOnboardingEventActions = (providerId: string) => {
  const addEventMutation = useAddProviderActivationEventMutation();

  const dispatchOnboardingEvent = async (eventName: ProviderActivationEventName, providerId: string) => {
    await addEventMutation.mutateAsync({ providerId, eventName });
  };

  return {
    welcomeVideoWatched: async () => dispatchOnboardingEvent(ProviderActivationEventName.introductionVideoCompleted, providerId),
    providerTrainingStarted: async () => dispatchOnboardingEvent(ProviderActivationEventName.trainingStarted, providerId),
    providerTrainingSubmitted: async () => dispatchOnboardingEvent(ProviderActivationEventName.trainingSubmitted, providerId),
    matchingAvailabilitySubmitted: async () => dispatchOnboardingEvent(ProviderActivationEventName.matchingAvailabilitySubmitted, providerId),
    matchingAvailabilityApproved: async () => dispatchOnboardingEvent(ProviderActivationEventName.matchingAvailabilityApproved, providerId),
    confettiDisplayed: async () => dispatchOnboardingEvent(ProviderActivationEventName.confettiDisplayed, providerId),
    stateSelectionSubmitted: async () => dispatchOnboardingEvent(ProviderActivationEventName.stateSelectionSubmitted, providerId),
  };
};
